export interface WarningResponse<Origin = unknown, Context = unknown, Payload = unknown> {
  warnings?: Report<Origin, Context, Payload>[];
}
export interface ErrorResponse<Origin = unknown, Context = unknown, Payload = unknown> {
  errors?: Report<Origin, Context, Payload>[];
}
export interface InfoResponse<Origin = unknown, Context = unknown, Payload = unknown> {
  infos?: Report<Origin, Context, Payload>[];
}
export function isErrorResponse(val?: unknown): val is ErrorResponse {
  const res = val as ErrorResponse | undefined;
  return res?.errors !== undefined && res.errors.every(isReport);
}
export function isWarningResponse(val?: unknown): val is WarningResponse {
  const res = val as WarningResponse | undefined;
  return res?.warnings !== undefined && res.warnings.every(isReport);
}

export function isInfoResponse(val?: unknown): val is InfoResponse {
  const res = val as InfoResponse | undefined;
  return res?.infos !== undefined && res.infos.every(isReport);
}
export function isReport(val?: any): val is Report {
  const report = val as Report | undefined;
  return report?.origin !== undefined;
}
export interface Report<Origin = unknown, Context = unknown, Payload = unknown> {
  origin: Origin;
  context: Context;
  payload: Payload;
}
